import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { clearUserData, cookies } from '@/shared'
import { authThunks } from '@/app/store/auth'
import { dictThunks } from '@app/store/dict'
import { useHistory, useLocation } from 'react-router-dom'
import { message } from 'antd'
import { t } from 'i18next'

export function useQuery() {
	const { search } = useLocation()

	return React.useMemo(() => new URLSearchParams(search), [search])
}

export const AuthorisePassport = ({ children }) => {
	let query = useQuery()

	const dispatch = useDispatch()
	const history = useHistory()
	useEffect(() => {
		return dispatch(
			authThunks.getCurrentUser(
				{
					data: { },
					history,
				},
				{ },
				() => {
					dispatch(dictThunks.getDictionaryVersion())
				},
			),
		)
	}, [dispatch, history])

	return <>{children}</>
}
